let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("g9AHD")), load("4P8R4")]).then(() => parcelRequire('5SP4f'));